import React, { type ReactNode } from "react";
import confettiReactionPath from "./CelebrationNotification/animations/confetti-reaction.json?url";
import fireReactionPath from "./CelebrationNotification/animations/fire-reaction.json?url";
import heartsReactionPath from "./CelebrationNotification/animations/hearts-reaction.json?url";
import pantherReactionPath from "./CelebrationNotification/animations/panther-reaction.json?url";
import panther from "./Icons/panther.png?url";

export interface BaseNotificationType {
    type: "CallEndNotification" | "SaleMadeNotification" | "Celebration";
    id: string;
}
export type Mascot = "Panthers" | "Raptors" | "Turtles" | "Bears" | "Mustangs" | "Hawks" | "Tigers";

export type Reaction = "Confetti" | "Fire" | "Hearts" | Mascot;

export interface SaleMadeNotificationType extends BaseNotificationType {
    props: {
        seller: {
            employeeName: string;
            employeeId: string;
            rank: number;
            teamSize: number;
            mascot: Mascot;
        };
    };
}

export interface CelebrationNotificationType extends BaseNotificationType {
    props: {
        sender: string;
        reactionType: Reaction;
    };
}

interface ApprovedReactions {
    id: Reaction;
    value: string | ReactNode;
    animationPath: string;
}

export const defaultReactions: ApprovedReactions[] = [
    { id: "Confetti", value: "🎉", animationPath: confettiReactionPath },
    { id: "Fire", value: "🔥", animationPath: fireReactionPath },
    { id: "Hearts", value: "❤️", animationPath: heartsReactionPath },
];

export const optionalReactions: ApprovedReactions[] = [
    {
        id: "Panthers",
        value: <img src={panther} alt="panther" height={32} width={32} />,
        animationPath: pantherReactionPath,
    },
];
